import { useCallback, useEffect, useRef, useState } from 'react';
import { useReportByFilter } from 'domains/ReportBuilder/model/selectors';
import {
  IUseDownloadStatisticsProps,
  IUseDpownloadStatisticsReturn,
} from './types';

export const useDownloadStatistics = ({
  formik,
  columns,
}: IUseDownloadStatisticsProps): IUseDpownloadStatisticsReturn => {

  const [disableGetReport, setDisableGetReport] = useState(true);

  const WorkerRef = useRef<Worker | null>(null);

  const { data: reports } = useReportByFilter();

  const isSafari = () =>
    /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  useEffect(() => {
    if (reports && !WorkerRef.current) {
      WorkerRef.current = new Worker('/workers/getReportStatistics.js?v=0.02');
      setDisableGetReport(false);
    }
  }, [reports]);

  const handleDownload = useCallback(() => {
    const payloadData = reports ?? {};

    if (WorkerRef.current) {
      WorkerRef.current.postMessage([columns, { rawData: payloadData }]);
      WorkerRef.current.onmessage = function (e) {
        const type = isSafari() ? 'application/csv' : 'text/csv';
        const blob = new Blob(['', e.data], { type });

        const URL = window.URL || window.webkitURL;

        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.setAttribute('download', `statistics.tsv`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        setDisableGetReport(false);
      };
      // eslint-disable-next-line no-param-reassign
      WorkerRef.current.onerror = function (e) {
        console.error({ e });
        setDisableGetReport(false);
      };
    }
  }, [WorkerRef, formik, columns, reports]);

  return {
    handleDownload,
    disableGetReport,
  };
};
